/** @jsx jsx */
import { jsx } from 'theme-ui'
import { number } from 'prop-types'

const Checked = ({ height = 12, width = 15, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 12"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.494 5.55l3.3 3.385L13.506 0 15 1.533 4.794 12h-.001L0 7.084l1.494-1.533z"
        fill="#304A3D"
      />
    </svg>
  )
}

Checked.propTypes = {
  height: number,
  width: number,
}

export default Checked
